import axios from "@lib/axios";

export default async function getRelayPoints(params) {
  if (params.carriers_to_request.length === 0) return [];

  const res = await axios.get("/carriers/find_relay_points", { params });
  return res.data.data;
}
